<template>
    <div class="dialog-warp loginWrap">
        <div class="email-logo">
            <img src="@/assets/ic_logo.png">
        </div>
        <div class="register-wrap">
            <div class="email-register-title">Sign in with Email</div>
            <div class="email-register-tip">Hi! Please register an email first</div>
        </div>
        <div class="register-input">
            <div>
                <el-input v-model="queryParams.email" placeholder="email account"></el-input>
                <el-input
                ref="passwordInput"
                class="mt10"
                v-model.trim="queryParams.password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Password"
                >
                    <template #suffix>
                        <i
                        class="el-icon-view"
                        :style="{ cursor: 'pointer' }"
                        @click="toggleField('password')"
                        ></i>
                    </template>
                </el-input>
                <el-input
                ref="confirmPasswordInput"
                :type="showConfirmPassword ? 'text' : 'password'"
                class="mt10"
                v-model.trim="confirmPassword"
                placeholder="Confirm password"
                >
                    <template #suffix>
                        <i
                        class="el-icon-view"
                        :style="{ cursor: 'pointer'}"
                        @click="toggleField('confirmPassword')"
                        ></i>
                        </template>
                </el-input>
            </div>
        </div>
        <div class="register-submit">
            <el-checkbox v-model="radio" label="1">
                <span>Agree to the </span>
                <router-link to="/privacy">Terms of Service</router-link>
                <span> and </span>
                <router-link to="/userAgree">Privacy Policy</router-link>
            </el-checkbox>
            <el-button round class="create-btn f16 font-MT mt20" size="medium" @click="toRegister" v-preventReClick="3000">Register now</el-button>
        </div>
    </div>
</template>
<script>
import { getEmailRegister } from "apiurl/login";
export default {
    name: 'EmailRegister',
    data() {
        return {
            queryParams: {
                email: '',
                password: '',
            },
            confirmPassword: '',
            radio: false,
            showPassword: false,
            showConfirmPassword: false,
            selectionMap: {
                password: { start: 0, end: 0 },
                confirmPassword: { start: 0, end: 0 }
            },

        };
    },
    mounted() {
        
    },
    methods: {
        toRegister() {
            if (!this.radio) {
                this.$message.error(this.$lang('tips.agreement'));
                return;
            };
            // 基础格式验证正则表达式（覆盖大多数常见情况）
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            if (this.queryParams.email == '') {
                this.$message.error(this.$lang('tips.cannotBeEmpty'));
                return;
            };

            if (!emailRegex.test(this.queryParams.email)) {
                this.$message.error(this.$lang('tips.format'));
                return;
            };
            if (this.queryParams.email.length > 50) {
                this.$message.error(this.$lang('tips.emailLength'));
                return;
            };
            
            if (this.queryParams.password === '') {
                this.$message.error(this.$lang('tips.inputPassword'));
                return;
            };
            if (this.queryParams.password.length < 8 || this.queryParams.password.length > 16) {
                this.$message.error(this.$lang('tips.passwordLength'));
                return;
            };
            if ( this.queryParams.password !== this.confirmPassword) {
                this.$message.error(this.$lang('tips.passwords'));
                return;
            };
            this.reqGetEmailRegister();
            
        },
        async reqGetEmailRegister() {
            try {
                let res = await getEmailRegister(this.queryParams);
                console.log(res, 'res');
                if (res.success) {
                    this.$message.success(this.$lang('tips.registeredSuccessfully'));
                    // 注册完成
                    this.goLogin();
                };
            } catch (error) {
                this.$message.error(this.$lang('tips.registerFailed'));
                console.log(error);
            };
        },
        toggleField(field) {
            const refName = `${field}Input`;
            const input = this.$refs[refName].$el.querySelector("input");
            this.selectionMap[field] = {
                start: input.selectionStart,
                end: input.selectionEnd
            };
            // 切换显示状态
            this[`show${this.capitalize(field)}`] = !this[`show${this.capitalize(field)}`];
            this.$nextTick(() => {
                input.setSelectionRange(
                    this.selectionMap[field].start,
                    this.selectionMap[field].end,
                );
                input.focus();
            });
        },
        capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        goLogin() {
            this.$emit('update-index', 2);
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/.el-input__suffix{
    display: flex;
    align-items: center;
    right: 10px;
}
.loginWrap{
    .email-logo{
        position: absolute;
        left: 50%;
        top: -50px;
        transform: translateX(-50%);
        >img{
            width: 96px;
            height: 96px;
        }
    }
    .register-wrap{
        margin-top: 58px;
        .email-register-title{
            font-family: 'AlimamaFangYuanTiVF';
            font-weight: 500;
            font-size: 36px;
            color: #000000;
            line-height: 30px;
            text-align: center;
        }
        .email-register-tip{
            margin-top: 17px;
            font-family: 'AlimamaFangYuanTiVF';
            font-size: 16px;
            color: #666666;
            line-height: 25px;
            text-align: center;
        }
    }
    .register-input{
        width: 360px;
        margin: 40px auto;
    }
    .register-submit{
        margin: 0 auto;
        width: 360px;
        display: flex;
        flex-direction: column;
        /deep/.el-checkbox{
            font-family: 'AlimamaFangYuanTiVF';
            font-weight: 400;
            font-size: 12px;
            color: #666;
            line-height: 31px;
            .el-checkbox__input.is-checked+.el-checkbox__label{
                color: #666 !important;
            }
            .el-checkbox__label{
                >a{
                    color: #666;
                    text-decoration: underline;
                }
            }
            .el-checkbox__input.is-checked .el-checkbox__inner::after {
                content: "";
                width: 10px;
                height: 10px;
                background: #FF049B;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                border: none;
            }
            .el-checkbox__input{
                &.is-checked{
                    .el-checkbox__inner{
                        background: transparent;
                        border-color: #FF049B;
                        &:hover{
                            border-color: #FF049B;
                        }
                    }
                }
                &.is-focus{
                    .el-checkbox__inner{
                        border-color: #FF049B;
                    }
                }
                .el-checkbox__inner{
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    &:hover{
                        border-color: #DCDFE6;
                    }
                }
            }
        }
        .el-button{
            width: 100%;
        }
    }
}
</style>